import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { TurnResource, turnsCancel } from '~/generated';
import { extractData } from '~/utils/query-utils';

type Variables = {
  cancellationReason: string;
  turnId: number;
  shiftId: number;
};

export const useTurnCancellation = (
  options: UseMutationOptions<TurnResource, unknown, Variables, unknown> = {}
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (variables: Variables) =>
      extractData(
        turnsCancel({
          path: { id: variables.turnId },
          body: { cancellationReason: variables.cancellationReason },
        })
      ),
    ...options,
    onSuccess(data, variables, mutationResult, context) {
      queryClient.invalidateQueries({ queryKey: ['turns', variables.turnId] });
      queryClient.invalidateQueries({
        queryKey: ['shifts', variables.shiftId],
      });
      options.onSuccess?.(data, variables, mutationResult, context);
    },
  });
};
